import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { OptionsGroup } from '@/vacancy_request/components/template-request-form/options-group';
import { optionsList, optionsValues } from '@/vacancy_request/components/template-request-form/options-group/constants';
import { useFormContext } from 'react-hook-form';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import { Separate } from '@components/styles/hr-styles';
import { CustomFieldsSection } from '@/vacancy_request/components/template-request-form/custom-fields/custom-fields-section';
import { CUSTOM_FIELD_TABS } from '@/vacancy_request/components/template-request-form/custom-fields/constants';

const VacancyInformationTab = (props) => {
  const { disabled } = props;
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form.stepTwo');
  const vacancyNameValue = watch('name');
  const disabilityValue = watch('apto_discapacitados');
  const workAreaValue = watch('c_area');

  const requiredValue = optionsValues.REQUIRED.toString();
  const optionalValue = optionsValues.OPTIONAL.toString();
  const disabledValue = optionsValues.DISABLED.toString();

  useEffect(() => {
    if (vacancyNameValue !== requiredValue) {
      setValue('name', requiredValue);
    }
  }, [setValue, vacancyNameValue]);

  useEffect(() => {
    if (!workAreaValue) return;

    const isSubAreaAvailableToUpdate = [requiredValue, optionalValue].includes(workAreaValue);
    if (!isSubAreaAvailableToUpdate) {
      setValue('c_subarea', disabledValue);
    }
  }, [workAreaValue]);

  useEffect(() => {
    if (disabilityValue === requiredValue) {
      setValue('apto_discapacitados', optionalValue);
    }
  }, [disabilityValue, setValue]);

  const buildDependentOptionDisabler = (parentValue) => (optionValue) => {
    if (parentValue === disabledValue) {
      return optionValue !== disabledValue;
    }
    if (parentValue === optionalValue) {
      return optionValue === requiredValue;
    }
    return false;
  };

  const isSubAreaOptionDisabled = buildDependentOptionDisabler(workAreaValue);

  const vacancyNameOptions = optionsList.filter((option) => option.value === requiredValue.toString());
  const disabilityOptions = optionsList.filter((option) => option.value !== requiredValue.toString());

  return (
    <>
      {/* Nombre del puesto */}
      <OptionsGroup
        name='name'
        label={t('fields.vacancyName.label')}
        options={vacancyNameOptions}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Área de trabajo */}
      <OptionsGroup name='c_area' label={t('fields.cArea.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Subárea de trabajo */}
      <OptionsGroup
        name='c_subarea'
        label={t('fields.cSubarea.label')}
        options={optionsList}
        disabled={disabled}
        isOptionDisabled={isSubAreaOptionDisabled}
      />
      <Separate margin='0' />

      {/* Modalidad de trabajo */}
      <OptionsGroup name='c_modality' label={t('fields.cModality.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Motivo de la búsqueda */}
      <OptionsGroup
        name='search_reason'
        label={t('fields.searchReason.label')}
        options={optionsList}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Posiciones a cubrir */}
      <OptionsGroup name='count_post' label={t('fields.countPost.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Tipo de empleo */}
      <OptionsGroup name='c_type_jobs' label={t('fields.cTypeJobs.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Puesto para personas con discapacidad */}
      <OptionsGroup
        name='apto_discapacitados'
        label='Puesto para personas con discapacidad'
        options={disabilityOptions}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Campos personalizados */}
      <CustomFieldsSection tab={CUSTOM_FIELD_TABS.VACANCY_DETAILS} disabled={disabled} />
    </>
  );
};

VacancyInformationTab.propTypes = {
  disabled: PropTypes.bool
};

VacancyInformationTab.defaultProps = {
  disabled: false
};

export default VacancyInformationTab;
